import React from "react";

const HeaderItem = (props) => {
  return (
    <li className="header-item">
      <img className="header-item-img" src={props.src} alt={props.alt} />
    </li>
  );
};

export default HeaderItem;
